const ErrorMessages = {
    'product': {
        'no_vsan_sub_product': 'Sélectionnez un cas d\'utilisation',
        'no_vsan_free_sub_product': 'Sélectionnez un cas d\'utilisation',
        'no_vhci_sub_product': 'Sélectionnez un cas d\'utilisation',
        'no_san_nas_sub_product': 'Sélectionnez un cas d\'utilisation',
        'nvme_hosts': 'Sélectionnez le nombre d\'hôtes initiateurs',
    },
    'firstname': {
        'validate_required': 'Le prénom est requis',
        'two_latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'firstname_lastname_match': 'Si cela correspond au prénom: Le prénom et le nom de famille ne peuvent pas être identiques',
        'fake_words': 'Veuillez entrer des données valides',
        'repeat_symbols': 'Format de nom invalide',
    },
    'lastname': {
        'validate_required': 'Le prénom est requis',
        'two_latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'firstname_lastname_match': 'Si cela correspond au prénom: Le prénom et le nom de famille ne peuvent pas être identiques',
        'fake_words': 'Veuillez entrer des données valides',
        'repeat_symbols': 'Format de nom invalide',
    },
    'email': {
        // 'validate_required': 'Corporate email is required',
        'validate_required': 'Une adresse e-mail d\'entreprise est requise',
        'validate_valid_email': 'Format d\'adresse e-mail invalide',
        'public_email': `Si une adresse e-mail gratuite ou publique est fournie: Une adresse e-mail affiliée à l'entreprise est requise. Si vous n'en avez pas, contactez <a href="mailto:sales@starwind.com">sales@starwind.com</a> pour obtenir de l'aide`,
    },
    'company': {
        'validate_required': 'Le nom de l\'entreprise est requis',
        'two_latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'repeat_symbols': 'Format de nom invalide',

    },
    'title': {
        'validate_required': 'Le titre de poste est requis',
        'two_latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'latin_and_whitespace': 'Seuls les caractères latins sont autorisés',
        'fake_words': 'Veuillez entrer des données valides',
        'repeat_symbols': 'Format de titre de poste invalide',
    },
    'phone': {
        'validate_required': 'Le numéro de téléphone est requis',
        'not_valid_phone_format': 'Format de numéro de téléphone invalide',
        'validate_phone_number': 'Format de numéro de téléphone invalide',
        'phone_number': 'Format de numéro de téléphone invalide',
    },
    'country': {
        'validate_required': 'Le nom du pays est requis',
    },
    'state': {
        'validate_required': 'État est requis',
        'no_country_state': 'État est requis'
    }
};

const errorPriority = function(error) {
    var res;
    // res = 0;
    switch (error) {
        case 'validate_required':
            res = 0;
            break;
        case 'fake_words':
            res = 4;
            break;
        case 'latin_and_whitespace':
            res = 5;
            break;
        default:
            res = 10;
    }
    return res;
}

const filterErrors = function(errors) {
    var key, obj;
    obj = {
        length: 0
    };
    for (key in errors) {
        if (key === 'length') {
            continue;
        }
        obj[key] = [errors[key][0]];
        obj.length += 1;
    }
    return obj;
}

const sortErrors = function (errors) {
    var key, obj, resObj, sortFunc;
    obj = {};

    for (key in errors) {
        if (key === 'length') {
            continue;
        }
        if (Array.isArray(errors[key])) {
            errors[key].forEach(function(element) {
                var priority;
                priority = errorPriority(element);
                if (obj[key] != null) {
                    return obj[key].push({
                        'rule': element,
                        'priority': priority
                    });
                } else {
                    return obj[key] = [
                        {
                            'rule': element,
                            'priority': priority
                        }
                    ];
                }
            });
        }
    }
    sortFunc = function(a, b) {
        var res;
        res = (+a.priority) - (+b.priority);
        return res;
    };
    for (key in obj) {
        obj[key].sort(sortFunc);
    }
    resObj = {
        length: 0
    };
    for (key in obj) {
        if (Array.isArray(errors[key])) {
            obj[key].forEach(function(element) {
                if (resObj[key] != null) {
                    resObj[key].push(element.rule);
                } else {
                    resObj[key] = [element.rule];
                }
                return resObj.length += 1;
            });
        }
    }
    return resObj;
}

export {sortErrors, filterErrors, ErrorMessages};
